<ion-header>
    <ion-toolbar>
        <ion-button fill="clear" slot="start" (click)="cancel()">Cancel</ion-button>
        <ion-title color="danger">Delete Account</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>


    <div sxPadding="medium">
        <h3 sxPadding="medium">By Continuing, you agree to delete all the following data permanently from the qid</h3>
        <div sxBackground="light" sxRadius="medium" sxPadding="medium" sxCol sxGap="5px">
            <p sxMargin="0">Profile Picture</p>
            <p sxMargin="0">Email Address</p>
            <p sxMargin="0">Phone Number</p>
            <p sxMargin="0">Contacts</p>
            <p sxMargin="0">Account Password</p>
        </div>

        <p sxPadding="medium">All the other details that you submitted on the app will be deleted permanently</p>

        <h3 sxPadding="medium medium small">What will not be deleted?</h3>

        <div sxBackground="light" sxRadius="medium" sxPadding="medium" sxCol sxGap="10px">
            <p sxMargin="0">The IDs that have been shared by you will remain not deleted. Those can't be further shared,
                edited or
                removed
            </p>
            <p sxMargin="0">Your Name will remain associated with the IDs and Transactions that you made</p>

        </div>

    </div>


    <page-action>
        <super-button [action]="continueDelete" [showError]="true" background="danger">Continue Delete</super-button>
    </page-action>


</ion-content>
